import React from "react";
import DashboardLayout from "../Components/Common/DashboardLayout";
import UserManagement from "../Components/Pages/Users/UserManagement";

const Users = () => {
  const content = {
    label: "User Management",
    component: <UserManagement />
  }

  return (
    <DashboardLayout content={content} />
  );
};

export default Users;